const actions = {
    download: (action, params, node, filesystem) => {
        filesystem.$axios.$get(params.link, { responseType: 'blob' })
            .then((response) => {
                const link = document.createElement('a')
                link.href = URL.createObjectURL(response)
                link.download = params.name
                link.click()
            })
    }
}

export { actions }
